import { useCallback, useEffect, useState, useRef } from 'react';
import { stylesheet } from 'typestyle';

import Popup from '@src/components/popups/product_detail/RingSizePopup';

const questionMark = '/images/question_mark_with_circle.svg';

const HELPER_VALUE = 'I DONT KNOW';

const qmCss = stylesheet({
  labelQuestionMark: {
    display: 'block',
    lineHeight: 0,
    cursor: 'pointer',
    height: 13,

    position: 'absolute',
    right: 9,
    top: 13
  }
});

export default function ValueInput ({ item }) {
  const questionMarkRef = useRef(null);
  const [showPopup, setShowPopup] = useState(false);
  const togglePopup = useCallback(
    (e) => {
      if (e) e.stopPropagation();
      setShowPopup(!showPopup);
    },
    [showPopup]
  );
  const closePopup = useCallback(() => setShowPopup(false));

  useEffect(
    () => {
      if (item && item[1] === HELPER_VALUE) {
        setShowPopup(true);
      } else {
        setShowPopup(false);
      }
    },
    [item]
  );

  if (item) {
    if (item[1] === HELPER_VALUE) {
      return (
        <span>
          I Don't Know
          <img
            src={questionMark}
            onClick={togglePopup}
            className={qmCss.labelQuestionMark}
            ref={questionMarkRef}
          />
          <Popup
            show={showPopup}
            onCloseClick={closePopup}
            anchorElement={questionMarkRef.current}
          />
        </span>
      );
    } else {
      return <span>Ring Size {item[0]}</span>;
    }
  } else {
    return <span>Select Ring Size</span>;
  }
}
